
import { defineComponent, onMounted } from "vue";

import { useDataTable } from "@tager/admin-ui";
import { getNameWithDepth } from "@tager/admin-services";
import { Page } from "@tager/admin-layout";

import { getCategoryList } from "@/services/requests";
import { CategoryType } from "@/typings/model";
import { getProductListUrl, getCategoryFormUrl } from "@/utils/paths";

export default defineComponent({
  name: "CategoryTree",
  components: {
    Page,
  },
  setup() {
    const {
      isLoading: isCategoryListLoading,
      rowData: categoryList,
      errorMessage,
      searchQuery,
      handleChange,
      fetchEntityList: fetchCategoryList,
    } = useDataTable<CategoryType>({
      fetchEntityList: (params) =>
        getCategoryList({ query: params.searchQuery }),
      initialValue: [],
      resourceName: "Category list",
    });

    onMounted(() => {
      fetchCategoryList();
    });

    return {
      categoryList,
      isCategoryListLoading,
      errorMessage,
      getCategoryFormUrl,
      getProductListUrl,
      searchQuery,
      handleChange,
      getNameWithDepth,
    };
  },
});
